var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-item"},[_c('div',{staticClass:"coupon-item-price"},[_vm._v("\n    "+_vm._s(_vm.couponInfo.value)),_c('span',[_vm._v("元")])]),_c('div',{staticClass:"coupon-item-desc"},[_c('h3',[_vm._v("职场通识课程"+_vm._s(_vm.couponInfo.value)+"元代金券")]),(_vm.endTime)?_c('p',[_vm._v("有效期至： "+_vm._s(_vm.endTime))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }